module.exports = __webpack_public_path__ + "static/img/pageOne.231a0a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageOne.png
// module id = 0wRR
// module chunks = 1